import { render, staticRenderFns } from "./DPBirthdayPicker.vue?vue&type=template&id=5c311a8e&"
import script from "./DPBirthdayPicker.vue?vue&type=script&lang=js&"
export * from "./DPBirthdayPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports